import React from 'react';
import { Modal } from "player-components";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";

import {ArrowDownTrayIcon, ExclamationTriangleIcon} from "@heroicons/react/20/solid";

import ReactGA from "react-ga4";

import { selectError, setError } from "../../features/ui/uiSlice";

const ErrorModalContainer = () => {


    const error = useSelector(selectError);
    const dispatch = useDispatch();

    return <>
    
    <Modal 
        isOpen={error?.text ? true:false}
        title={error? error.title: ''}
        text={<p>{error? error.text: ''}</p>}
        // confirmLabel="Okay"
        // icon={<ExclamationTriangleIcon className="h-20 w-20 text-primary" aria-hidden="true" />}
        onConfirm={()=>dispatch(setError(null))}
        onClose={()=>dispatch(setError(null))}
        closeLabel="Close"
      />
    </>
}

export default ErrorModalContainer;